<div class="drilldown-dialog">
    <header class="drilldown-header">
        <div class="title-block">
            <h2>{{ title }}</h2>
            <p class="sub">
                <span class="numeric">{{ data.startDate | date:'MM/dd/yyyy' }}</span>
                <span *ngIf="data.startDate.toString() !== data.endDate.toString()">
                    &nbsp;→&nbsp;
                    <span class="numeric">{{ data.endDate | date:'MM/dd/yyyy' }}</span>
                </span>
                <span *ngIf="data.locationId != null"> · Location #<span class="numeric">{{ data.locationId }}</span></span>
                <span *ngIf="rows.length"> · <span class="numeric">{{ rows.length }}</span> row(s)</span>
            </p>
        </div>
        <button class="kbma-btn kbma-btn--ghost" (click)="close()">Close</button>
    </header>

    <!-- Simple *ngIf branches. Since we now pre-load the rows in the parent
         before opening the dialog, there are no transitions between viewStates
         that the Material Dialog overlay needs to repaint — the dialog opens
         already in the correct final state. -->
    <div *ngIf="viewState === 'loading'" class="drilldown-loading">
        Loading…
        <button class="cancel-link" (click)="close()">Cancel</button>
    </div>
    <div *ngIf="viewState === 'error'" class="drilldown-error">
        <strong>Error:</strong> {{ error }}
    </div>
    <div *ngIf="viewState === 'empty'" class="drilldown-empty">
        No records.
    </div>
    <div *ngIf="viewState === 'data'" class="drilldown-table-wrap">
        <table class="kbma-table">
            <thead>
                <tr>
                    <th *ngFor="let c of columns()" [ngClass]="(c.type === 'num' || c.type === 'money') ? 'numeric' : ''">{{ c.header }}</th>
                </tr>
            </thead>
            <tbody>
                <tr *ngFor="let r of rows" (click)="onRowClick(r)" class="clickable">
                    <td *ngFor="let c of columns()" [ngClass]="(c.type === 'num' || c.type === 'money') ? 'numeric' : ''">
                        <a *ngIf="c.type === 'propertyLink' && r[c.field] != null; else plainCell"
                           class="str-link"
                           [href]="propertyEditUrl(r[c.field])"
                           target="_blank"
                           rel="noopener noreferrer"
                           (click)="$event.stopPropagation()">{{ format(r, c) }}</a>
                        <ng-template #plainCell>
                            <span [ngClass]="(c.type === 'num' || c.type === 'money' || c.type === 'date') ? 'numeric' : ''">{{ format(r, c) }}</span>
                        </ng-template>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
